import AnnualReturnsOrderState from "@dana/Store/Pages/AnnualReturnsOrder/AnnualReturnsOrderState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { ProductPriceDto } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: AnnualReturnsOrderState = {
    productInfos: [],
    balance: 0,
    balanceDisplay: "0",
    isOrderValid: false,
    showContactModal: false,
};

const reducer = createTypedReducerWithImmer(initialState, {
    "Pages/AnnualReturnsOrder/ChangeProductQtyOrdered": (
        draft: Draft<AnnualReturnsOrderState>,
        action: { productId: string; qtyOrdered: number; },
    ) => {
        const productInfo = draft.productInfos.find(
            o => o.productId === action.productId
        );
        if (productInfo) {
            productInfo.qtyOrdered = action.qtyOrdered;
        }
    },
    "Pages/AnnualReturnsOrder/ClearProducts": (draft: Draft<AnnualReturnsOrderState>) => {
        draft.productInfos = [];
    },
    "Pages/AnnualReturnsOrder/RemoveProduct": (
        draft: Draft<AnnualReturnsOrderState>,
        action: { productId: string },
    ) => {
        draft.productInfos = draft.productInfos.filter(
            o => !(o.productId === action.productId),
        );
    },
    "Pages/AnnualReturnsOrder/BeginAddProduct": () => { },
    "Pages/AnnualReturnsOrder/CompleteAddProduct": (draft: Draft<AnnualReturnsOrderState>, action: { productInfo: ProductInfo }) => {
        const existingProduct = draft.productInfos.find(
            o => o.productId === action.productInfo.productId,
        );
        if (!existingProduct) {
            draft.productInfos.unshift(action.productInfo);
        } else {
            existingProduct.qtyOrdered = action.productInfo.qtyOrdered;
        }
    },
    "Pages/AnnualReturnsOrder/UpdateBalance": (
        draft: Draft<AnnualReturnsOrderState>,
        action: { balance: number, balanceDisplay: string },
    ) => {
        draft.balance = action.balance;
        draft.balanceDisplay = action.balanceDisplay;

    },
    "Pages/AnnualReturnsOrder/UpdateValidity": (
        draft: Draft<AnnualReturnsOrderState>,
        action: { isOrderValid: boolean },
    ) => {
        draft.isOrderValid = action.isOrderValid;
    },
    "Pages/AnnualReturnsOrder/ShowContactModal": (
        draft: Draft<AnnualReturnsOrderState>,
        action: { showContactModal: boolean },
    ) => {
        draft.showContactModal = action.showContactModal;
    },
});

(reducers as any).annualReturnsOrderState = reducer;

type AnnualReturnsOrderReducers = {
    annualReturnsOrderState: typeof reducer;
};

export type AnnualReturnsOrderActions = Parameters<AnnualReturnsOrderReducers[keyof AnnualReturnsOrderReducers]>[1] | AnyAction;